import { render, staticRenderFns } from "./NoticeListing.vue?vue&type=template&id=0628d4f4&"
import script from "./NoticeListing.vue?vue&type=script&lang=js&"
export * from "./NoticeListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports